interface HeroSectionProps {
  onDownload: () => void;
}

const stats = [
  { value: "2,500+", label: "已归档截图" },
  { value: "每日多次", label: "线索更新" },
  { value: "分栏对照", label: "原始片段" },
];

export default function HeroSection({ onDownload }: HeroSectionProps) {
  return (
    <section id="top" className="w-full pt-28 md:pt-36 pb-16 md:pb-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.55fr_1fr] lg:items-end lg:gap-14">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-price-tag-3-line"></i>
              专题合集浏览 · 按主题分类整理
            </span>

            <h2 className="mt-6 text-3xl leading-[1.25] font-bold tracking-tight text-foreground-950 md:text-[2.9rem] md:leading-[1.18]">
              把暗网流出的第一手资料，
              <br className="hidden sm:block" />
              收进一个可以慢慢翻的<strong className="text-primary-600">专题合集</strong>
            </h2>

            <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
              黑网爆料整理暗网截图、网络信息与隐藏线索，按主题分类归档，支持直接对比原始片段。
              更新快，少了来回翻找，看暗网流出物料时，拿完整线索的速度更快。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#gallery"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-image-2-line text-base"></i>
                进入截图大图库
              </a>
              <button
                type="button"
                onClick={onDownload}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
              >
                <i className="ri-download-cloud-2-line text-base"></i>
                下载完整线索
              </button>
            </div>

            <dl className="mt-10 flex flex-wrap gap-x-10 gap-y-4 border-t border-background-200 pt-6">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt className="text-xs text-foreground-500">{item.label}</dt>
                  <dd className="mt-1 text-lg font-semibold text-foreground-950">{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="animate-fade-up" style={{ animationDelay: "0.12s" }}>
            <figure className="relative overflow-hidden rounded-lg border border-background-200">
              <div className="h-64 w-full md:h-[300px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20dark%20editorial%20abstract%20artwork%20of%20scattered%20encrypted%20documents%20and%20anonymous%20data%20fragments%20drifting%20in%20deep%20charcoal%20darkness%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20film%20grain%2C%20moody%20atmospheric%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=1200&height=900&seq=hnb-hero-01&orientation=landscape"
                  alt="黑网爆料 暗网流出 线索专题封面"
                  className="h-full w-full object-top"
                />
              </div>
              <figcaption className="flex items-center gap-2 border-t border-background-200 bg-background-100 px-4 py-3 text-xs text-foreground-600">
                <i className="ri-bookmark-line"></i>
                本期封面 · 暗网流出物料索引
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}